import React from 'react';

// Ported verbatim from the praytoday-launcher prototype so the shipped launcher
// keeps the hand-drawn line work the mockup established.
const frame = (children) => (
  <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" aria-hidden="true">{children}</svg>
);

export const PrayerMark = () => frame(
  <>
    <path className="fill" d="M24 8.5c-2.6 3.4-4.6 5.9-4.6 9a4.6 4.6 0 0 0 9.2 0c0-3.1-2-5.6-4.6-9z" />
    <path d="M24 8.5c-2.6 3.4-4.6 5.9-4.6 9a4.6 4.6 0 0 0 9.2 0c0-3.1-2-5.6-4.6-9z" />
    <path className="fine" d="M24 13.2c-1.1 1.6-2 2.9-2 4.4a2 2 0 0 0 4 0c0-1.5-.9-2.8-2-4.4z" />
    <path className="fine" d="M13.5 10.5l2.3 2.3M34.5 10.5l-2.3 2.3M11 18h3.2M33.8 18H37" />
    <path d="M20.5 24.5h7l-.6 12.5h-5.8z" />
    <path className="fine" d="M23 27.5c0 2 .9 2.4.9 4.3M25.4 30.8c0 1.5-.6 2-.6 3.4" />
    <path d="M15.5 39.5c1.8-1.7 4.6-2.5 8.5-2.5s6.7.8 8.5 2.5" />
    <path className="fine" d="M18 42.5h12" />
  </>
);

export const BibleMark = () => frame(
  <>
    <path className="fill" d="M24 16c-3.4-2.6-8.2-3.4-14-3.4v22.8c5.8 0 10.6.8 14 3.4 3.4-2.6 8.2-3.4 14-3.4V12.6c-5.8 0-10.6.8-14 3.4z" />
    <path d="M24 16c-3.4-2.6-8.2-3.4-14-3.4v22.8c5.8 0 10.6.8 14 3.4 3.4-2.6 8.2-3.4 14-3.4V12.6c-5.8 0-10.6.8-14 3.4z" />
    <path d="M24 16v22.8" />
    <path className="fine" d="M14 18.5c2.6.2 4.9.7 6.8 1.6M14 23c2.6.2 4.9.7 6.8 1.6M14 27.5c2.6.2 4.9.7 6.8 1.6M34 18.5c-2.6.2-4.9.7-6.8 1.6M34 23c-2.6.2-4.9.7-6.8 1.6M34 27.5c-2.6.2-4.9.7-6.8 1.6" />
    <path d="M27.5 13.8V22l2.2-1.8 2.2 1.8v-9.4" />
    <path className="fine" d="M24 9V4.5M19 9.8l-1.6-3M29 9.8l1.6-3" />
  </>
);

export const DevotionalMark = () => frame(
  <>
    <path className="fill" d="M15 30a9 9 0 0 1 18 0z" />
    <path d="M15 30a9 9 0 0 1 18 0" />
    <path className="fine" d="M19.5 30a4.5 4.5 0 0 1 9 0" />
    <path d="M24 12.5V8M32.2 15.8l3.2-3.2M15.8 15.8l-3.2-3.2M37 24h4.5M6.5 24H11" />
    <path className="fine" d="M29.3 13.9l1.2-2.8M18.7 13.9l-1.2-2.8" />
    <path d="M8 30h32" />
    <path className="fine" d="M11 34.5c2.2 1.6 4.3 1.6 6.5 0 2.2 1.6 4.3 1.6 6.5 0 2.2 1.6 4.3 1.6 6.5 0 2.2 1.6 4.3 1.6 6.5 0" />
    <path className="fine" d="M15 39c2.2 1.6 4.3 1.6 6.5 0 2.2 1.6 4.3 1.6 6.5 0 2.2 1.6 4.3 1.6 6.5 0" />
  </>
);

export const GenerateMark = () => frame(
  <>
    <path className="fill" d="M38 8c-9 1.5-16.5 6-20.5 14.5-1.6 3.4-2.3 6.8-2.5 9.5 2.9-.2 6.3-1 9.7-2.6C33.2 25.4 37 17.5 38 8z" />
    <path d="M38 8c-9 1.5-16.5 6-20.5 14.5-1.6 3.4-2.3 6.8-2.5 9.5 2.9-.2 6.3-1 9.7-2.6C33.2 25.4 37 17.5 38 8z" />
    <path className="fine" d="M33 13c-6.5 4.2-11.5 9.3-15.5 16.5" />
    <path d="M15 32c-1.8 1.8-2.8 4.4-3 8 3.6-.2 6.2-1.2 8-3" />
    <path className="fine" d="M12 40.5h13" />
    <path d="M38.5 30l.9 2.6 2.6.9-2.6.9-.9 2.6-.9-2.6-2.6-.9 2.6-.9z" />
    <path className="fine" d="M10.5 12l.7 2 2 .7-2 .7-.7 2-.7-2-2-.7 2-.7z" />
  </>
);

export const ScheduleMark = () => frame(
  <>
    <rect className="fill" x="8" y="11" width="32" height="29" rx="4.5" />
    <rect x="8" y="11" width="32" height="29" rx="4.5" />
    <path d="M8 19.5h32" />
    <path d="M17 7v7.5M31 7v7.5" />
    <path className="fine" d="M15.5 8.5a1.5 3 0 0 1 3 0M29.5 8.5a1.5 3 0 0 1 3 0" />
    <circle className="fine" cx="15.5" cy="25.5" r="1.1" />
    <circle className="fine" cx="24" cy="25.5" r="1.1" />
    <circle className="fine" cx="32.5" cy="25.5" r="1.1" />
    <circle className="fine" cx="15.5" cy="33" r="1.1" />
    <circle className="fine" cx="32.5" cy="33" r="1.1" />
    <circle cx="24" cy="33" r="4" />
    <path className="fine" d="M24 30.8v2.2l1.5 1" />
  </>
);
